import { render, staticRenderFns } from "./drugInstruction.vue?vue&type=template&id=76ca5d44&"
import script from "./drugInstruction.vue?vue&type=script&lang=js&"
export * from "./drugInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports